// 区域、资产组相关
/** 设备 */
export const MACHINE = 'Machine'
/** 分摊部门 */
export const APPORTION_DEPARTMENT = 'apportion_department'
/** 业务资产组 */
export const BUSINESS = 'business'
/** 仪表资产组 */
export const METER = 'meter'
/** 抄表区域 */
export const RECORD_AREA = 'recordArea'
/** 能源部门 */
export const ENERGY_SECTOR = 'energySector'
